"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRowType = void 0;
var IRowType;
(function (IRowType) {
    IRowType["MyList"] = "MyList";
    IRowType["QuickFinds"] = "QuickFinds";
    IRowType["Challenges"] = "Challenges";
    IRowType["IncludedWorkouts"] = "IncludedWorkouts";
    IRowType["Categories"] = "Categories";
    IRowType["Query"] = "Query";
})(IRowType || (exports.IRowType = IRowType = {}));
//# sourceMappingURL=row-type.js.map